import { Box, Link, Typography, useTheme } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import { Layout } from "src/components/common";

interface PrivacyType {
  title: string;
  body: JSX.Element;
}

export const PrivacyPage: React.FC = () => {
  const theme = useTheme();
  const { t } = useTranslation();
  const policyClauses: PrivacyType[] = [
    {
      title: t("privacy.clauses.item1.title"),
      body: <>{t("privacy.clauses.item1.body")}</>,
    },
    {
      title: t("privacy.clauses.item2.title"),
      body: <>{t("privacy.clauses.item2.body")}</>,
    },
    {
      title: t("privacy.clauses.item3.title"),
      body: <>{t("privacy.clauses.item3.body")}</>,
    },
    {
      title: t("privacy.clauses.item4.title"),
      body: <>{t("privacy.clauses.item4.body")}</>,
    },
    {
      title: t("privacy.clauses.item5.title"),
      body: <>{t("privacy.clauses.item5.body")}</>,
    },
    {
      title: t("privacy.clauses.item6.title"),
      body: <>{t("privacy.clauses.item6.body")}</>,
    },
    {
      title: t("privacy.clauses.item7.title"),
      body: <>{t("privacy.clauses.item7.body")}</>,
    },
    {
      title: t("privacy.clauses.item8.title"),
      body: (
        <>
          {t("privacy.clauses.item8.body.item1")}
          <Link href="mailto:contact@shuluntc.com"> {t("privacy.clauses.item8.body.item2")}</Link>
          {t("privacy.clauses.item8.body.item3")}
        </>
      ),
    },
    {
      title: t("privacy.clauses.item9.title"),
      body: <>{t("privacy.clauses.item9.body")}</>,
    },
  ];

  return (
    <Layout>
      <Box
        sx={{
          pt: "65px",
          m: "100px auto 200px",
          width: "1200px",
          maxWidth: "calc(100% - 250px)",
          color: "#323e59",
          [theme.breakpoints.down("md")]: { m: "60px 72px 120px", width: "auto", maxWidth: "none" },
          [theme.breakpoints.down("sm")]: { m: "60px 32px 120px" },
        }}
      >
        <Box mb="40px">
          <Typography
            sx={{
              fontSize: "clamp(20px,1.5vw,24px)",
              fontWeight: "500",
              letterSpacing: "0.03em",
              lineHeight: 2,
            }}
          >
            {t("privacy.sub_title")}
          </Typography>
          <Typography
            sx={{
              fontSize: "clamp(32px,4.125vw,66px)",
              fontWeight: "300",
              letterSpacing: "-0.07em",
              lineHeight: 1.4,
              mb: "20px",
            }}
          >
            {t("privacy.title")}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", flexDirection: "column", gap: "26px" }}>
          <Typography sx={{ fontSize: "clamp(14px,1vw,16px)", fontWeight: "400" }}>{t("privacy.synopsis")} </Typography>
          {policyClauses.map(clause => (
            <Box key={clause.title}>
              <Typography sx={{ m: "24px 0 16px", fontSize: "clamp(20px,1.75vw,28px)", fontWeight: "500" }}>{clause.title}</Typography>
              <Typography sx={{ fontSize: "clamp(14px,1vw,16px)", fontWeight: "400", whiteSpace: "pre-wrap" }}>{clause.body}</Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Layout>
  );
};

export default PrivacyPage;
